import { Text } from '@yes.technology/react-toolkit'
import { useTranslation } from 'react-i18n-lite'

import type { GanttCaption } from 'site/Renderer/components/GanttChart/Gantt.utils'
import {
  CaptionLegendRow,
  CaptionSwatch,
  CaptionsStack
} from './GanttCockpitSidebar.styles'

const DEFAULT_SWATCH = '#abbed1'

export type GanttCockpitCaptionsProps = {
  captions: GanttCaption[]
}

const GanttCockpitCaptions = ({ captions }: GanttCockpitCaptionsProps) => {
  const { t } = useTranslation()

  if (captions.length === 0) {
    return null
  }

  return (
    <CaptionsStack data-testid='gantt-cockpit-captions'>
      <Text variant='content-emphasis-04'>{t('gantt.legend')}:</Text>
      {captions.map((caption) => {
        const translationKey = `gantt.captions.${caption.id}`
        const translatedLabel = t(translationKey)
        const resolvedLabel =
          translatedLabel === translationKey ? caption.label : translatedLabel

        return (
          <CaptionLegendRow key={caption.id}>
            <CaptionSwatch $color={caption.color ?? DEFAULT_SWATCH} />
            <Text variant='content-emphasis-04'>{resolvedLabel}</Text>
          </CaptionLegendRow>
        )
      })}
    </CaptionsStack>
  )
}

export default GanttCockpitCaptions
